// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NuestrosClientesGridLogos_clientesSection__xT52D {
  background-color: #000000;
  padding: 4rem 1.5rem;
}

.NuestrosClientesGridLogos_inner__Ojafn {
  max-width: 1200px;
  margin: 0 auto;
}

.NuestrosClientesGridLogos_title__odccK {
  text-align: center;
  color: #ffffff;
  font-weight: 700;
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  margin: 0 0 2.5rem;
}

/* Grid de logos */
.NuestrosClientesGridLogos_grid__dUXXA {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 2rem 2.5rem;
  align-items: center;
  justify-items: center;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
}

.NuestrosClientesGridLogos_item__jH8HG {
  display: flex;
  align-items: center;
  justify-content: center;
}

.NuestrosClientesGridLogos_logo__\\+W5d3 {
  max-width: 170px;
  width: 100%;
  height: auto;
  object-fit: contain;
  filter: grayscale(1);
  opacity: 0.9;
  transition: transform 0.2s ease, opacity 0.2s ease, filter 0.2s ease;
}

.NuestrosClientesGridLogos_logo__\\+W5d3:hover {
  transform: scale(1.05);
  opacity: 1;
  filter: grayscale(0);
}

/* Mobile */
@media (max-width: 640px) {
  .NuestrosClientesGridLogos_clientesSection__xT52D {
    padding: 3rem 1.25rem;
  }

  .NuestrosClientesGridLogos_grid__dUXXA {
    gap: 1.5rem 1rem;
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NuestrosClientesGridLogos.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,oDAAoD;EACtD;AACF","sourcesContent":[".clientesSection {\n  background-color: #000000;\n  padding: 4rem 1.5rem;\n}\n\n.inner {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.title {\n  text-align: center;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: clamp(1.8rem, 3vw, 2.4rem);\n  margin: 0 0 2.5rem;\n}\n\n/* Grid de logos */\n.grid {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 2rem 2.5rem;\n  align-items: center;\n  justify-items: center;\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo {\n  max-width: 170px;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  filter: grayscale(1);\n  opacity: 0.9;\n  transition: transform 0.2s ease, opacity 0.2s ease, filter 0.2s ease;\n}\n\n.logo:hover {\n  transform: scale(1.05);\n  opacity: 1;\n  filter: grayscale(0);\n}\n\n/* Mobile */\n@media (max-width: 640px) {\n  .clientesSection {\n    padding: 3rem 1.25rem;\n  }\n\n  .grid {\n    gap: 1.5rem 1rem;\n    grid-template-columns: repeat(2, minmax(120px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clientesSection": `NuestrosClientesGridLogos_clientesSection__xT52D`,
	"inner": `NuestrosClientesGridLogos_inner__Ojafn`,
	"title": `NuestrosClientesGridLogos_title__odccK`,
	"grid": `NuestrosClientesGridLogos_grid__dUXXA`,
	"item": `NuestrosClientesGridLogos_item__jH8HG`,
	"logo": `NuestrosClientesGridLogos_logo__+W5d3`
};
export default ___CSS_LOADER_EXPORT___;
